import * as React from 'react';
import { useMemo } from 'react';

export class BlockContext {
  static Context = React.createContext();
  attributes;
  Block;
  constructor(attributes, Block) {
    this.attributes = attributes;
    this.Block = Block;
  }
}

export function BlockViewer({ block: Block }) {
  return function Viewer({ ...attributes }) {
    const context = useMemo(() => new BlockContext(attributes, Block), [
      Block,
      attributes,
    ]);
    const Provider = BlockContext.Context.Provider;
    return (
      <Provider value={context}>
        <Block {...attributes} />
      </Provider>
    );
  };
}
// This was an idea, but it need more digging
// export function BlockStatic({block: Block, attributes}){
//   const context = useMemo(() => new BlockContext(attributes, Block), [
//     Block,
//     attributes,
//   ]);
//   const Provider = BlockContext.Context.Provider;
//   return (
//       <Provider value={context}>
//         <Block {...attributes} />
//       </Provider>
//   );
// }
